
class BlockTextCards{

	constructor() {

		let blocks = document.querySelectorAll('.block-text-cards');

		blocks.forEach( (block) => {

			let cards = block.querySelectorAll('.cards');
			cards.forEach((card) => {
				let content = card.querySelector('.text');
				if(content) {
					card.addEventListener('mouseenter', () => {
						content.style.maxHeight = content.scrollHeight + "px";
						content.style.overflow = "auto";
					});
					card.addEventListener('mouseleave', () => {
						content.style.maxHeight = null;
						content.style.overflow = "hidden";
					});
				}
			});
		});

	}

}